import { BaseDto } from '../../core';
import { PRODUCT_SHIPPING_TYPE } from '../../shared';

export class CartCreateDto extends BaseDto<CartCreateDto> {
  constructor(partial?: any) {
    super(partial);

    this.isForce = partial.isForce || false;
  }
  mapperSaleProductId: number;
  quantity: number;
  shippingType: PRODUCT_SHIPPING_TYPE;
  isForce: boolean;
}
